export default $wire => ({
    value: $wire.entangle('value').live,

    isChecked(optionValue) {
        return this.value.includes(optionValue);
    },
});
